var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button",staticStyle:{"padding":"16px"}},[_c('van-button',{attrs:{"round":"","block":"","type":"danger"},on:{"click":_vm.submit}},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }